import {CustomerNotice,normalizeNotice,noticeIdAtMost} from './notificationTarget'
export type ReminderState={notice:CustomerNotice|null;opening:boolean;error:string}
type ReminderOptions={identity:()=>string;enabled:()=>boolean;list:()=>Promise<any>;open:(item:CustomerNotice)=>Promise<boolean>;read:(id:string)=>Promise<any>;changed:(state:ReminderState)=>void;readDone?:(id:string)=>void;shouldMarkRead?:(item:CustomerNotice)=>boolean}

// 前台会话与路由独立：关弹窗不已读，切换普通页面不重弹；回前台重新核对未读。
export const createNotificationReminder=(options:ReminderOptions)=>{
  let generation=0,key='',reminded=false,loading=false,hidden=false,disposed=false
  let state:ReminderState={notice:null,opening:false,error:''}
  const update=(patch:Partial<ReminderState>)=>{state={...state,...patch};options.changed(state)}
  const current=(run:number,identity:string)=>!disposed && !hidden && run===generation && !!identity && identity===options.identity() && identity===key
  const load=async()=>{
    if(disposed || hidden || reminded || loading || !key || key!==options.identity() || !options.enabled())return
    const run=generation,identity=key;loading=true
    try{
      const response=await options.list()
      if(!current(run,identity) || reminded || !options.enabled())return
      const rows=Array.isArray(response.data?.items)?response.data.items:[]
      const notice=rows.map(normalizeNotice).find((row:CustomerNotice|null)=>row && !row.readed)
      if(notice){reminded=true;update({notice,error:''})}
    }catch{/* 后台弱网静默，后续轮询或重新进入前台重试。 */}
    finally{if(run===generation)loading=false}
  }
  const begin=()=>{
    generation++;key=options.identity();reminded=false;loading=false
    update({notice:null,opening:false,error:''})
    return load()
  }
  return {
    load,
    identityChanged:begin,
    foreground(){hidden=false;return begin()},
    background(){hidden=true;generation++;loading=false;update({notice:null,opening:false,error:''})},
    dismiss(){generation++;loading=false;reminded=true;update({notice:null,opening:false,error:''})},
    invalidateRead(id?:string,maxId?:string){if(state.notice && (id?state.notice.id===id:maxId?noticeIdAtMost(state.notice.id,maxId):true)){generation++;loading=false;reminded=true;update({notice:null,opening:false,error:''})}},
    async view(){
      if(!state.notice || state.opening || !options.enabled())return
      const item=state.notice,run=generation,identity=key
      if(!current(run,identity))return
      update({opening:true,error:''})
      try{
        if(!await options.open(item))throw Error('暂时无法打开，请重试')
        if(!current(run,identity))return
        if(options.shouldMarkRead?.(item)===false){update({notice:null});return}
        await options.read(item.id)
        if(!current(run,identity))return
        update({notice:null});options.readDone?.(item.id)
      }catch(error){if(current(run,identity))update({error:(error as Error).message || '打开或标记失败，请重试'})}
      finally{if(current(run,identity))update({opening:false})}
    },
    dispose(){disposed=true;generation++;loading=false}
  }
}
